export default {
  getSuccess: (state) => state.meta.success,
};
